import { Pipe, PipeTransform } from '@angular/core';
import { StatusStyle, StatusStyleMap } from './status-style.entities';
import { defaultStatusStyle } from './status-style.styles';

@Pipe({
  name: 'statusStyle',
})
export class StatusStylePipe implements PipeTransform {
  transform<S extends string>(
    status: S | undefined,
    styles: StatusStyleMap<S>,
  ): StatusStyle {
    if (status === undefined) {
      return defaultStatusStyle;
    }
    return styles[status] ?? defaultStatusStyle;
  }
}
